import * as S from './layout';

interface Props {
  header: string;
  value: string;
}

export const CalendarDate = (props: Props) => {
  return (
    <S.Root>
      <S.Top>{props.header}</S.Top>
      <span>{props.value}</span>
    </S.Root>
  );
};

export type CalendarDateProps = Props;
